export default "https://cdn-static.gokick.com/assets/f1ffb082694ccd599c5c343ec9cae3a0a74687d7/images/gokick-home-thumb.d0805bfbe5c122bc4415664ec8f6d56b.png";